<p-dialog
  data-testid="detail-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '1000px', maxWidth: '95vw' }"
  [header]="getDialogHeader()"
  (onHide)="onCancel()"
>
  <!-- Search Form -->
  <div class="mb-4">
    <app-search-form
      data-testid="detail-dialog-search-form"
      [searchFormat]="searchFormat"
      (formSearch)="onSearch($event)"
      (formReset)="onSearchReset()"
    ></app-search-form>
  </div>

  <!-- SKU Selection Table -->
  <div class="mb-4">
    <app-data-table
      data-testid="detail-dialog-table"
      [dataSource]="skuItems"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalRecords"
      [rows]="20"
      [selection]="selectedSkus"
      (selectionChange)="selectedSkus = $event"
      [hasCheckColumn]="true"
      [hasHeaderCheckbox]="true"
      [hasSerialColumn]="false"
      [isRowSelectedFn]="getSkuSelectionState.bind(this)"
      (pageChange)="onLazyLoad($event)"
      [scrollHeight]="'450px'"
      class="w-full"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <!-- Cancel button -->
      <app-button
        [testId]="'detail-dialog-cancel-btn'"
        label="inbound.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading()"
      ></app-button>

      <!-- Add button -->
      <app-button
        [testId]="'detail-dialog-add-btn'"
        label="inbound.actions.add"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="loading()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="detail-dialog-toast"></p-toast>
